import { Component, OnInit , AfterViewChecked, ElementRef, ViewChild } from '@angular/core';
import { ChatService } from '../chat.service';
// import { Observable } from 'rxjs/Observable';
import { scan } from 'rxjs/operators';
import { Msg } from 'src/app/_models/msg';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-chat-dialog',
  templateUrl: './chat-dialog.component.html',
  styleUrls: ['./chat-dialog.component.scss']
})
export class ChatDialogComponent implements OnInit, AfterViewChecked {
  @ViewChild('scrollMe',{static: false} ) private myScrollContainer: ElementRef;

  messages: Observable<Msg[]>;
  formValue: string;
  constructor(private chat: ChatService) {
  } 
  ngOnInit() {
    // appends to array after each new message is added to feedSource 
    this.messages = this.chat.conversation.asObservable().pipe(scan((acc, val) => acc.concat(val)));//.scan((acc, val) => acc.concat(val));
    //this.sendMessage();
    this.scrollToBottom();      
  }
  ngAfterViewChecked() {        
    this.scrollToBottom();        
  } 
  public chatHelper(msg) {
    this.chat.talk(msg);
  }
  sendMessage() {
    this.chat.converse(this.formValue);
    this.formValue = '';
  }

  scrollToBottom(): void {
    try {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch(err) { }                 
  }
}
